(function() {
    'use strict';

    angular
        .module('app.feriados')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/feriados',
                config: {
                    templateUrl: 'app/feriados/feriados.html',
                    controller: 'Feriados',
                    controllerAs: 'vm',
                    title: 'Feriados'
                }
            },
            {
                url: '/editar-feriado/:id?',
                config: {
                    templateUrl: 'app/feriados/editarFeriado.html',
                    controller: 'EditarFeriado',
                    controllerAs: 'vm',
                    title: 'EditarFeriado'
                }
            }
        ];
    }
})();
